import { styled } from '@mui/material/styles';
import { Modal, Box, Typography, Paper, Popper } from '@mui/material';

export const StyledModal = styled(Modal)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300
}));

export const StyledPopper = styled(Popper)(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 'var(--Spacing-md, 8px)',
        background: 'var(--white, #FFF)',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.32)',
    },
    '& .MuiAutocomplete-listbox': {
        padding: theme.spacing(1),
    },
    '& .MuiAutocomplete-option': {
        borderRadius: 'var(--Spacing-sm, 4px)',
        '&[aria-selected="true"], &.Mui-focused, &:hover': {
            background: 'var(--orange, #F9AA2A) !important',
        },
    },
}));

export const ModalContent = styled(Box)(({ theme, direction, hasIframe }) => ({
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: 24,
    padding: theme.spacing(2),
    maxWidth: '100vw',
    maxHeight: '95vh',
    overflow: 'auto',
    
    width: hasIframe ? '1500px' : '850px', // Dynamic width based on iframe presence
    direction: direction,
    display: 'flex', // Added flex display
    flexDirection: 'row' // Added row direction
}));

export const SectionTitle = styled(Typography)(({ theme, direction }) => ({
    fontSize: '16px',
    fontWeight: 600,
    color: '#304FFF',
    borderBottom: '2px solid #304FFF',
    paddingBottom: theme.spacing(0.2),
    marginBottom: theme.spacing(0.8)
}));

export const FormSection = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    marginBottom: theme.spacing(0.8),
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    position: 'relative'
}));

export const FieldTitle = styled(Typography)(({ theme }) => ({
    fontSize: '15px',
    fontWeight: 500,
    color: '#333',
    display: 'flex',
    alignItems: 'center',
    minWidth: '120px',
    marginRight: theme.spacing(1)
}));

export const FieldRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

export const TotalSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: theme.spacing(1.5),
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    marginTop: theme.spacing(0.5)
}));